import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "RankTeam" }
const _hoisted_2 = { class: "RankTeam__rank" }
const _hoisted_3 = {
  key: 1,
  class: "RankTeam__normal"
}
const _hoisted_4 = { class: "RankTeam__avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "RankTeam__info" }
const _hoisted_7 = { class: "RankTeam__nickname" }
const _hoisted_8 = { class: "RankTeam__obtain" }
const _hoisted_9 = { class: "RankTeam__prize" }
const _hoisted_10 = { class: "RankTeam__buff" }
const _hoisted_11 = { class: "RankTeam__sub" }
const _hoisted_12 = {
  key: 1,
  class: "RankTeam__nobuff"
}

import {realStrLength, cutStr} from '@/utils/text';

export default /*#__PURE__*/_defineComponent({
  props: {
    rank: null,
    options: null
  },
  setup(__props: any) {




function teamNameParse (str: string) {
  if (realStrLength(str) >= 18) {
    return cutStr(str.replace('的队伍', ''), 9, '...的队伍');
  } else {
    return str;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.rank <= 3)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({
          RankTeam__first: __props.rank === 1,
          RankTeam__second: __props.rank === 2,
          RankTeam__third: __props.rank === 3,
        })
          }, null, 2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.rank >= 100 ? '99+' : __props.rank), 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "RankTeam__img",
        src: __props.options.leaderImg
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(teamNameParse(__props.options.name)), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.options.totalInfo), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (__props.rank <= 3)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(__props.options.expansionInfo), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(__props.options.leaderObtainInfo), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, "无奖励"))
    ])
  ]))
}
}

})